<div *ngIf="hasContainerWideClass" class="grid">
  <div [ngClass]="'container container--wide'">
    <ft-bar-chart *ngFor="let chart of data" [data]="chart"></ft-bar-chart>
  </div>
</div>
<div *ngIf="!hasContainerWideClass">
  <ft-bar-chart *ngFor="let chart of data" [data]="chart"></ft-bar-chart>
</div>
